import React, {useContext, useEffect, useRef, useState} from 'react';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import Messages from '@core/scripts/components/messages';
import {articleOverviewStaticContext} from '../../ArticleOverviewStatic.jsx';
import FilterGroupContent from '../FilterGroupContent.jsx';
import {Accordion} from '@bonprix/design-system';
import Ordering from '../../header/Ordering.jsx';

function FilterGroups({filterGroups, ordering, filterOptionChange, orderingChange, classes}) {
    const {texts} = useContext(articleOverviewStaticContext);

    const [isMounted, setIsMounted] = useState(false);
    const [selectedOrderingName, setSelectedOrderingName] = useState(ordering.find((option) => option.selected).name);
    const activeIdentifiers = useRef([]);

    useEffect(() => {
        setTimeout(() => {
            setIsMounted(true);
        }, 0);
        MessageBroker.publish(Messages.DOM.CHANGED);
    }, []);

    const handleOrderingChange = (value, landmark, name) => {
        setSelectedOrderingName(name);
        orderingChange(value, landmark);
    };

    return (
        <div className={`filter__groups-accordion ${classes}`} jsh-accordion-wrapper="">
            <Accordion>
                {ordering && renderOrdering()}
                {filterGroups.map((filterGroup) => {
                    return renderFilterGroup(filterGroup);
                })}
            </Accordion>
        </div>
    );

    function renderOrdering() {
        return (
            <Accordion.Item
                key="ordering"
                title={`${texts.sort}: ${selectedOrderingName}`}
                initiallyOpened={false}
                onOpen={() => saveActiveIdentifier('ordering')}
                onClose={() => saveActiveIdentifier('ordering')}
            >
                {isMounted && <Ordering ordering={ordering} handleOrderingChange={handleOrderingChange} />}
            </Accordion.Item>
        );
    }

    function renderFilterGroup(filterGroup) {
        let isActive = activeIdentifiers.current.includes(filterGroup.identifier);
        const withSelection = filterGroup.selectionLabel !== '';
        const label = `${filterGroup.name}${withSelection ? `: ${filterGroup.selectionLabel}` : ''}`;

        return (
            <Accordion.Item
                key={filterGroup.identifier}
                title={label}
                initiallyOpened={isActive}
                onOpen={() => saveActiveIdentifier(filterGroup.identifier)}
                onClose={() => saveActiveIdentifier(filterGroup.identifier)}
            >
                {isMounted && (
                    <FilterGroupContent
                        filterGroup={filterGroup}
                        filterOptionChange={filterOptionChange}
                        preventFilterUpdate={false}
                    />
                )}
            </Accordion.Item>
        );
    }

    function saveActiveIdentifier(identifier) {
        const currentState = activeIdentifiers.current.includes(identifier);
        if (!currentState) {
            activeIdentifiers.current.push(identifier);
        } else {
            activeIdentifiers.current = activeIdentifiers.current.filter((item) => item !== identifier);
        }
    }
}

export default React.memo(FilterGroups);
